(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('validateInputDate', validateInputDate);

  // @ngInject
  function validateInputDate(DateUtil) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        minDate: '@',
        maxDate: '@'
      },
      link: function ($scope, element, attrs, ngModelController) {

        ngModelController.$options = {
          updateOn: 'blur',
          updateOnDefault: false
        };

        ngModelController.$formatters.push(format);

        ngModelController.$parsers.push(parseInput);


        function parseInput(input) {
          var inputDate = moment(input);
          var minDate = $scope.minDate;
          var maxDate = $scope.maxDate;

          var isInputValid = false;

          if(inputDate.isValid()){
            if(minDate && inputDate.diff(minDate) >= 0){
              if(maxDate && inputDate.diff(maxDate) <= 0){
                isInputValid = true;
              }
            }
          }

          var formatted;
          if (isInputValid) {
            // set the view back to the formatted model value
            formatted = format(input);
          } else {
            formatted = format(ngModelController.$modelValue);
          }

          ngModelController.$setViewValue(formatted);
          ngModelController.$render();

          return formatted;
        }

        function format(value) {
          var momentObj = value && moment(value);
          if(momentObj.isValid()){
            return DateUtil.shortMonthDate(momentObj);
          } else {
            return "";
          }
        }

      }
    };
  }


})();